import { t } from "@lingui/macro";
import graphql from "babel-plugin-relay/macro";
import { useFragment } from "react-relay";

import { CardScroller } from "@whoosh/design-system/src/components/display";
import { Box, Text } from "@whoosh/design-system/src/components/primitive";

import { EventCardWrapper } from "../EventCardWrapper";
import { FeaturedEventsScrollerEventConnection$key } from "./__generated__/FeaturedEventsScrollerEventConnection.graphql";

type FeaturedEventsMobileEventsScrollerProps = {
  nodeRef: FeaturedEventsScrollerEventConnection$key | null;
  hasNext: boolean;
  isLoadingNext: boolean;
  loadNext: (count: number) => void;
};

export const FeaturedEventsScroller = ({
  nodeRef,
  hasNext,
  isLoadingNext,
  loadNext,
}: FeaturedEventsMobileEventsScrollerProps) => {
  const data = useFragment(FeaturedEventsScrollerFragment, nodeRef);

  const events =
    data?.edges?.map((eventsEdge) => {
      return {
        node: eventsEdge?.node,
        id: eventsEdge?.node?.id ?? "",
      };
    }) || [];

  const onEndReached = () => {
    if (hasNext && !isLoadingNext) {
      loadNext(20);
    }
  };

  if (events.length === 0) {
    return null;
  }

  return (
    <Box width="100%">
      <CardScroller
        data={events || []}
        titleElement={
          <Text variant="mainTitle3" pr={6} color="text-primary">
            {t`Featured Events`}
          </Text>
        }
        isLoading={isLoadingNext}
        hasMoreItems={hasNext}
        onEndReached={onEndReached}
        renderItem={(item) =>
          item ? (
            <Box width={312}>
              <EventCardWrapper
                isFeatured
                eventCardWrapperRef={item?.node ?? null}
              />
            </Box>
          ) : null
        }
      />
    </Box>
  );
};

const FeaturedEventsScrollerFragment = graphql`
  fragment FeaturedEventsScrollerEventConnection on EventConnection {
    edges {
      node {
        id
        ...EventCardWrapper
      }
    }
  }
`;
